import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export default function Forbidden() {
  const navigate = useNavigate();
  const location = useLocation() as any;
  const requiredPermission = location?.state?.requiredPermission as string | undefined;
  const requiredPermissions = location?.state?.requiredPermissions as string[] | undefined;
  const requireAll = location?.state?.requireAll as boolean | undefined;

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-lg w-full space-y-6 text-center">
        <div className="flex justify-center">
          <AlertTriangle className="h-12 w-12 text-red-500" />
        </div>
        <h1 className="text-2xl font-semibold">Acesso negado</h1>
        <p className="text-muted-foreground">
          Você não tem permissão para acessar esta página.
        </p>
        {requiredPermission ? (
          <p className="text-sm text-muted-foreground">
            Permissão necessária: <strong>{requiredPermission}</strong>
          </p>
        ) : null}
        {requiredPermissions && requiredPermissions.length > 0 ? (
          <div className="text-sm text-muted-foreground">
            <p>
              Permissões necessárias ({requireAll ? "todas" : "qualquer uma"}):
            </p>
            <ul className="list-disc list-inside mt-2 text-left">
              {requiredPermissions.map((perm) => (
                <li key={perm}>
                  <strong>{perm}</strong>
                </li>
              ))}
            </ul>
          </div>
        ) : null}
        <div className="flex gap-3 justify-center">
          <Button variant="secondary" onClick={() => navigate(-1)}>Voltar</Button>
          <Button asChild>
            <Link to="/">Ir para a página inicial</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
